"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _view = _interopRequireDefault(require("@react-x/view"));

var _Toggle = _interopRequireDefault(require("../Toggle"));

var _Window = _interopRequireDefault(require("../Window"));

var _DropdownContent = _interopRequireDefault(require("./DropdownContent"));

// Libraries
// Components
var Dropdown = function Dropdown(_ref) {
  var trigger = _ref.trigger,
      onBlur = _ref.onBlur,
      children = _ref.children,
      style = _ref.style;
  return _react["default"].createElement(_Toggle["default"], {
    onClose: function onClose() {
      return onBlur && onBlur();
    }
  }, function (_ref2) {
    var isOpen = _ref2.isOpen,
        handleOpen = _ref2.handleOpen,
        handleClose = _ref2.handleClose,
        handleToggle = _ref2.handleToggle;
    return _react["default"].createElement(_Window["default"], {
      onOutsideClick: handleClose
    }, function (_ref3) {
      var ref = _ref3.ref;
      return _react["default"].createElement(_view["default"], {
        ref: ref,
        style: style
      }, trigger({
        isOpen: isOpen,
        handleOpen: handleOpen,
        handleClose: handleClose,
        handleToggle: handleToggle
      }), children({
        isOpen: isOpen,
        handleClose: handleClose
      }));
    });
  });
};

Dropdown.Content = _DropdownContent["default"];
var _default = Dropdown;
exports["default"] = _default;